import PropTypes from 'prop-types';
import React from 'react';

const ProgressBar = ({
  fillColor,
  outline,
  progress,
  style,
}) => (
  <Container
    fillColor={fillColor}
    outline={outline}
    style={style}
  >
    <Fill
      fillColor={fillColor}
      progress={progress}
    />
  </Container>
);

ProgressBar.defaultProps = {
  fillColor: '#16b9d4',
  progress: 0,
};

ProgressBar.propTypes = {
  fillColor: PropTypes.string,
  style: PropTypes.object,
};

const Container = ProgressBar.Container = ({
  children,
  style,
}) => (
  <div
    style={{
      backgroundColor: '#d8d8d8',
      borderRadius: '1em',
      display: 'block',
      height: '0.5em',
      overflow: 'hidden',
      ...style,
    }}
  >
    {children}
  </div>
);

const Fill = ProgressBar.Fill = ({
  fillColor = '#16b9d4',
  progress,
}) => (
  <div
    style={{
      height: '100%',
      width: `${progress}%`,
      backgroundColor: fillColor,
      boxSizing: 'border-box',
    }}
  />
);

export default ProgressBar;
